angular.module('app.shared.guidService', [])
	.factory('app.shared.guidService', [function () {
		var newGuid = function () {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		}

		return {
			newGuid: newGuid
		};
	}]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/guidService.js